export default class ApiEndPoints {
    static employees = 'api/users/employees';

    static suppliers = 'api/users/suppliers';

    static managers = 'api/users/managers';

    static account = 'api/accounts';

    static activateAccount = 'api/accounts/activate';

    static uploads = 'api/uploads';

    static accountResetPasswordRequest = 'api/accounts/passwords/requests/send';

    static accountResetPassword = 'api/accounts/passwords/requests/reset';

    static supplierRegister = 'api/accounts/suppliers';

    static purchaseOrders = 'api/purchaseOrders';

    static PurchaseOrdersMy = 'api/purchaseOrders/my';

    static userLogin = 'api/authorization/login';

    static userLogout = 'api/authorization/logout';

    static userInfo = 'api/authorization/userInfo';

    static pdf = 'api/pdf';

    static roles = 'api/roles';

    static clients = 'api/clients';

    static subordinates = 'api/subordinates';

    static subordinatesClients = 'api/subordinates/clients'

    static printLabels = '/api/printLabels'
}
